module.exports = __webpack_public_path__ + "static/media/star4.9b992c59.svg";